import React from "react";

const SvgMessagesBubbleSquare = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M21.5 2h-19A1.5 1.5 0 001 3.5v13A1.5 1.5 0 002.5 18h4.252a.25.25 0 01.25.25v3.25a.5.5 0 00.853.354l3.781-3.781a.253.253 0 01.177-.073H21.5a1.5 1.5 0 001.5-1.5v-13A1.5 1.5 0 0021.5 2z" />
  </svg>
);

export default SvgMessagesBubbleSquare;
